import React from 'react';
import { InfraFeature } from '../../data/industryData';
import '../../styles/InfraFeatures.css';

interface InfraFeaturesProps {
  features: InfraFeature[];
}

const InfraFeatures: React.FC<InfraFeaturesProps> = ({ features }) => {
  return (
    <div className="infra-features-section">
      <div className="infra-features-container">
        <h2 className="infra-features-title">Specialized Infrastructure Solutions</h2>
        <p className="infra-features-subtitle">
          Our tailored infrastructure capabilities address the unique requirements of your industry
        </p>
        
        <div className="infra-features-grid">
          {features.map((feature, index) => (
            <div className="infra-feature-card" key={index}>
              <div className="infra-feature-header">
                <div className="infra-feature-icon">
                  {typeof feature.icon === 'string' ? feature.icon : '⚙️'}
                </div>
                <h3 className="infra-feature-title">{feature.title}</h3>
              </div>
              <p className="infra-feature-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default InfraFeatures; 